import dayjs from 'dayjs';
import { DayJsDateType } from 'types/date';

const isBiggerDate = (date1: DayJsDateType, date2: DayJsDateType) => {
  if (!date1 || !date2) {
    return false;
  }

  const dateJs1 = dayjs(date1).startOf('date');
  const dateJs2 = dayjs(date2).startOf('date');

  return dateJs1.isAfter(dateJs2);
};

export default isBiggerDate;
